var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "android_svg__a",
    d: "M1 5h17.8v10H1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "android_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#android_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .3-.3.7-.7.7zm-8.2 0c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .3-.3.7-.7.7zM14.2 8l1.5-2.6c.1-.1 0-.3-.1-.4-.1-.1-.3 0-.4.1l-1.5 2.6c-1.1-.5-2.4-.8-3.8-.8s-2.7.3-3.8.8L4.6 5.2C4.5 5 4.3 5 4.2 5c-.2.1-.2.3-.1.5L5.5 8C3 9.4 1.3 12 1 15h17.8c-.3-3-2-5.6-4.6-7z",
    style: {
      clipPath: "url(#android_svg__b)"
    }
  }));
};
export default SvgAndroid;